/* eslint-disable no-useless-catch */
import api from "@/api/public/index";

export default {
  state: {
    cherkassyRegions: null,
    regions: null,
  },
  mutations: {
    setCherkassyRegions(state, payload) {
      state.cherkassyRegions = payload;
    },
    setRegions(state, payload) {
      state.regions = payload;
    },
  },
  actions: {
    async getRegionsData({ commit }) {
      try {
        const regions = (await api.regions.getRegions()).data;

        commit("setRegions", regions);
      } catch (e) {
        throw e;
      }
    },
  },
};
